import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import OurMission from "./sections/OurMission";
import MeetTheExperts from "./sections/MeetTheExperts";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <OurMission />
      <MeetTheExperts />
      <CommonQuestions />
      <Footer />
    </div>;
}